import { useContext } from 'react';
import { MegaMenuMobileContext } from '@context/MegaMenuMobileContext';
import type { MegaMenuMobileContextValue } from '@context/MegaMenuMobileContext';

export function useMegaMenuMobile(): MegaMenuMobileContextValue {
  const ctx = useContext(MegaMenuMobileContext);
  if (!ctx)
    throw new Error('useMegaMenuMobile must be used within MegaMenuMobile');
  return ctx;
}
